import backButton from '@/components/generics/back-button/back-button.vue';
import closeButton from '@/components/generics/close-button/close-button.vue';
import marketHeaderMixin from '@/mixins/marketHeader';

export default {
  mixins: [
    marketHeaderMixin,
  ],
  components: {
    backButton,
    closeButton,
  },
  props: {
    backButton: {
      type: Boolean,
      default: false,
    },
    closeButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classModifier() {
      return {
        'market-header-title__header': true,
        'market-header-title__header--left-padding': this.backButton,
        'market-header-title__header--right-padding': this.watchIconVisible || this.closeButton,
      };
    },
  },
  methods: {
    onClick() {

    },
    close() {
      this.$emit('close');
    },
    back() {
      this.$emit('back');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-header-title/market-header-title.js